import { render, staticRenderFns } from "./DesignSkinInfo.vue?vue&type=template&id=d494f814&scoped=true&"
import script from "./DesignSkinInfo.vue?vue&type=script&lang=ts&"
export * from "./DesignSkinInfo.vue?vue&type=script&lang=ts&"
import style0 from "./DesignSkinInfo.vue?vue&type=style&index=0&id=d494f814&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d494f814",
  null
  
)

export default component.exports